export default __webpack_public_path__ + "static/media/powered_by_pw.f3593ec3.png";